import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import moment from "moment";

const ProjectSlice = createSlice({
  name: "Project",
  initialState: {
    currentMenuAction: false,
    offcanvasStatus: false,
    isMobileMenuOpen: false,
    currentActiveContentTab: "Dashboard",
    DarkTheme: Cookies.get("DARK_THEME_ACTIVE") == "light" ? false : Cookies.get("DARK_THEME_ACTIVE") == "dark" ? true : false,
    searchBoxStatus: false,
    currentOpenNav: "",
    currentEmployee: "",
    isJWT_TockenValid: Cookies.get("LUG_JWT_TOKEN") || null,
    isLoginUserValid: Cookies.get("LUG_USER_ID") || null,
    tokenUniqueCode: "",
    UserName: "",
    Password: "",
    coreType :"Family",
    filterData: {
      // startDate: new Date(),
      // endDate: new Date(),
      startDate: new Date().toISOString(),
      endDate: new Date().toISOString(),
    },
    screenShotFilterDate: moment(new Date()).format("DD-MM-YYYY"),
    currentEmployeeData: null,
    editId: "",
    pageActions: {},
    filteredNavbarData: [],
    IsMerged: "",
    refreshKey: 0,

  },
  reducers: {
    toggleOffcanvasStatus: (state, action) => {
      state.offcanvasStatus = action.payload;
    },
    toggleMobileMenu: (state, action) => {
      state.isMobileMenuOpen = action.payload;
    },
    toggleCurrentMenuActionStatus: (state, action) => {
      state.currentMenuAction = action.payload;
    },
    handleCurrentActiveCurrentTab: (state, action) => {
      state.currentActiveContentTab = action.payload;
    },
    handleSetCoreType :(state,action)=>{
      state.coreType = action.payload
    },
    handleDarkThemeStatus: (state, action) => {
      state.DarkTheme = action.payload;
    },
    handleSearchBoxStatus: (state, action) => {
      state.searchBoxStatus = action.payload;
    },
    handleCurrentOpenMenuList: (state, action) => {
      state.currentOpenNav = action.payload;
    },
    setFilterData: (state, action) => {
      state.filterData[action.payload.name] = action.payload.value;
    },
    handleSetCurrentEmployee: (state, action) => {
      state.currentEmployee = action?.payload?.employee_id || "";
      state.currentEmployeeData = action.payload;
    },
    handleScreenShotFilterDate: (state, action) => {
      state.screenShotFilterDate = action?.payload?.value;
    },

    setFilteredNavbarData: (state, action) => {
      state.filteredNavbarData = action.payload;
    },
    setIsMerged: (state, action) => {
      state.IsMerged = action.payload;
    },
    setRefreshKey: (state, action) => {
      const nextValue = (state.refreshKey + 1) % 101;
      state.refreshKey = nextValue;
    },
  },
});

export const {
  toggleOffcanvasStatus,
  toggleMobileMenu,
  toggleCurrentMenuActionStatus,
  handleCurrentActiveCurrentTab,
  handleDarkThemeStatus,
  handleSearchBoxStatus,
  handleCurrentOpenMenuList,
  setFilterData,
  handleSetCurrentEmployee,
  handleScreenShotFilterDate,
  setFilteredNavbarData,
  setIsMerged,
  setRefreshKey,
  handleSetCoreType,
  setDynamicTotalAmont
} = ProjectSlice.actions;
export default ProjectSlice.reducer;
